import React, { useState } from 'react';
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { _T } from "../../../../../base-react/src/Localization";
import { Button, Dropdown, notification } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ScheduleRoundSource = models.rounds.ScheduleRoundSource;
var ScheduleSource = models.schedules.ScheduleSource;
import { useSchedulePages } from '../../../../../base-react/hooks/Schedule';
export const ScheduleMoveTo = (props) => {
    const { event_id, selection, disabled } = props;
    const [schedule, loadingSchedule] = Stream(ScheduleSource(event_id));
    const { pages, pageData } = useSchedulePages(event_id, schedule);
    const [loading, setLoading] = useState(false);
    const items = pages && pages.length > 1 ? pages.map((page, index) => ({
        label: page.schedule_value,
        key: index,
        children: pageData[index].map(data => ({
            label: data.schedule_value,
            key: data.schedule_id
        }))
    })) : pageData[0].map(data => ({
        label: data.schedule_value,
        key: data.schedule_id
    }));
    const onClick = async (e) => {
        setLoading(true);
        try {
            const rounds = await Api.read(ScheduleRoundSource(event_id, e.key).url);
            const selectionIds = selection.map((a) => a.children ? a.children.map(c => c.round_id) : a.round_id).flat();
            const roundIds = rounds.map((a) => a.round_id);
            const updateIds = roundIds.concat(selectionIds);
            await Api.call(ScheduleRoundSource(event_id, e.key).url, "set-order", updateIds);
        }
        catch (err) {
            notification.error({
                message: err.message
            });
        }
        setLoading(false);
    };
    if (loadingSchedule) {
        return React.createElement(Button, { disabled: true, loading: true, icon: React.createElement(ExportOutlined, null) }, _T('schedule.moveTo.label'));
    }
    return (React.createElement(Dropdown, { menu: { items, onClick }, trigger: ['click'], disabled: disabled || selection.length == 0 },
        React.createElement(Button, { loading: loading, disabled: selection.length == 0, icon: React.createElement(ExportOutlined, null) }, _T('schedule.moveTo.label'))));
};
